@if (association) {
	<div
		class="c-vloket-association-card {{ classes }}"
		[ngClass]="{ 'c-vloket-association-card--with-shadow': disableShadow }"
	>
		@if (!withLink) {
			<h2 class="c-vloket-header c-vloket-header--h4 u-no-margin-bottom">
				{{ association.names | associationName }}
			</h2>
		} @else {
			<h4 class="c-vloket-header c-vloket-header--h4 u-no-margin-bottom">
				<a
					class="u-link--no-decoration"
					cypressTag="AssociationCard.Link"
					[ngClass]="{ 'icon-open-externally': target === '_blank' }"
					[title]="association.names?.full"
					[routerLink]="link"
					[target]="target"
					>{{ association.names | associationName }}</a
				>
			</h4>
		}

		@if (association.names?.short || association.names?.callName) {
			<div>
				<b>{{ association.names.full }}</b>
			</div>
		}

		<p class="c-association-card__meta u-margin-bottom">
			@if (association.associationType) {
				<span class="c-association-card__meta__item">{{ association?.associationType.description }}</span>
			}
			@if (association?.organisationNumber) {
				<span class="c-association-card__meta__item">{{ association.organisationNumber | btw }}</span>
			}
			@if (association?.associationNumber) {
				<span class="c-association-card__meta__item">{{ association.associationNumber }}</span>
			}
			@if (association?.startDate) {
				<span class="c-association-card__meta__item"
					>{{ I18nKeys.SharedAssociations.Card.DatePrefix | translate }}
					{{ association.startDate | date: 'dd-MM-yyyy' }}</span
				>
			}
		</p>

		@if (association.locations) {
			<cjm-tag class="u-margin-bottom u-no-padding" icon="fa-location-dot" iconType="fa-solid">{{
				association.locations | mainLocation | oneLineAddress
			}}</cjm-tag>
		}

		<div class="c-vloket-association-card__tags u-margin-bottom-xl">
			@if (association.mainActivities) {
				<vloket-association-detail-activities [activities]="association.mainActivities" />
			}
			@if (association.targetAudience) {
				<vloket-association-target-audience-tags [targetAudience]="association.targetAudience" />
			}
		</div>

		<ul class="c-vloket-association-card__contact-info">
			@for (item of association.contactInfoList | mainContactInfo; track item) {
				<li>
					<fa-icon [icon]="item.icon" [iconType]="item.iconType" />
					<a class="c-vloket-text--single-line-clip" target="_blank" [href]="item.url">{{ item.label }}</a>
				</li>
			}
		</ul>

		<!-- Denis: Optional slot to add additional content like buttons -->
		<ng-content />
	</div>
}
